import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  Box,
  Typography,
  Popover,
  List,
  ListItem,
  ListItemText,
  ListItemIcon
} from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { Customer as Agent } from 'src/icons/customer';
import { logOutService, selectUser } from '../features/auth/authSlice';
import { useAppDispatch, useAppSelector } from '../hooks/useStore';
import { usePopover } from '../hooks/use-popover';
import { ChevronDown as ChevronDownIcon } from '../icons/chevron-down';
import { Logout as LogoutIcon } from '../icons/logout';
import { Users as UsersIcon } from '../icons/users';

const ListItemIconStyled = styled(ListItemIcon)(() => ({
  minWidth: 0,
  marginRight: 12
}));

interface AccountPopoverProps {
  // onLanguageChange: (newLanguage: 'fr' | 'it' | 'es') => void;
}

export const HeaderPopover: FC<AccountPopoverProps> = (props) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const [anchorRef, open, handleOpen, handleClose] = usePopover();

  const handleLogout = async (): Promise<void> => {
    try {
      handleClose();
      await dispatch(logOutService());
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  const fullName = `${user?.prenom ?? 'Prénom'} ${user?.nom ?? 'Nom'}`;
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'grid',

        gridTemplateColumns: {
          sm: 'auto 1fr auto',
          xs: 'auto'
        },
        justifyItems: 'flex-start'
      }}
    >
      <Box
        onClick={handleOpen}
        ref={anchorRef}
        sx={{
          alignItems: 'center',
          cursor: 'pointer',
          display: 'flex',
          ml: 2
        }}
        {...props}
      >
        <Agent sx={{ color: 'text.secondary' }} />
        <Typography sx={{ ml: 1.5, color: 'primary.dark' }} variant="subtitle2">
          {fullName}
        </Typography>
        <ChevronDownIcon
          sx={{
            color: 'primary.dark',
            ml: 1
          }}
        />
      </Box>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom'
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        PaperProps={{
          sx: {
            width: 'auto',
            display: 'flex',
            flexDirection: 'column',
            marginTop: 2
          }
        }}
      >
        <List>
          <ListItem divider>
            <ListItemIconStyled>
              <Agent />
            </ListItemIconStyled>
            <ListItemText primary={fullName} secondary={user?.profile} />
          </ListItem>
          <ListItem
            button
            component={RouterLink}
            divider
            onClick={handleClose}
            to="/dashboard/users/list"
          >
            <ListItemIconStyled>
              <UsersIcon />
            </ListItemIconStyled>
            <ListItemText primary="List des clients" />
          </ListItem>
          <ListItem button onClick={handleLogout} data-testid="logout-button">
            <ListItemIconStyled>
              <LogoutIcon />
            </ListItemIconStyled>
            <ListItemText primary="Se déconnecter" />
          </ListItem>
        </List>
      </Popover>
    </Box>
  );
};
